import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {MyBetsRow} from './MyBetsRow';
import {BoxWrpr} from './BoxWrpr';
import {useTranslation} from 'react-i18next';
import {StepForm} from '../../../models/api/codegen/code';
import { getPlayerIdFromHeader, getSteps } from '../../../spirsApi/api-client';
import {tab} from "../MyBets";
import { UpButton } from '../../Line/UpButton';


type MyBetsTableProps = {
    calculated: undefined | boolean;
    actualDate: Date;
    currentTab: tab;
}


export function MyBetsTable(props: MyBetsTableProps) {

    const { t } = useTranslation();
    const [steps, setSteps] = useState<StepForm[]>([]);
    const playerId = getPlayerIdFromHeader();
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        playerId && getSteps({
            playerId, startTime: props.actualDate.toISOString(), calculated: props.calculated
        }).then(data => {
            data && setSteps(data);
            setLoaded(true);
        })
    }, [props.calculated, props.actualDate, playerId])

    const [showScrollToTop, setShowScrollToTop] = React.useState(false);
    const listRef = React.useRef<HTMLDivElement>(null);
            
     React.useEffect(() => {
         const handleScroll = () => {
            if (listRef.current) {
            const firstElement = listRef.current.firstChild as HTMLElement;
            if (firstElement) {
            const rect = firstElement.getBoundingClientRect();
             // Если элемент частично или полностью скрыт
                 if (rect.top < 0) {
                   setShowScrollToTop(true);
                } else {
                   setShowScrollToTop(false);
                      }
                    }
                  }
                };
            
    window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
             };
     }, []);

    return (
        <div className="flex flex-col text-[16px]">
            <div className="flex bg-[#121518] px-[24px] py-[16px] mb-[7px] items-center gap-4">
                <div className="flex flex-grow-[1] basis-0 max-w-[50px] text-center text-[12px] notebook:!text-[14px]">{'#'}</div>
                <BoxWrpr fg={2}>{t('myBets.header.sportName')}</BoxWrpr>
                <BoxWrpr fg={2}>{t('myBets.header.stepIndex')}</BoxWrpr>
                <BoxWrpr fg={4}>{t('myBets.header.stepId')}</BoxWrpr>
                <BoxWrpr fg={1} center>{t('myBets.header.odds')}</BoxWrpr>
                <BoxWrpr fg={1} center>{t('myBets.header.rate')}</BoxWrpr>
                <BoxWrpr fg={1} center>{t('myBets.header.winResult')}</BoxWrpr>
                <BoxWrpr fg={2} center>{t('myBets.header.status')}</BoxWrpr>
            </div>
            {steps.length > 0 && (
                <div ref={listRef}>
                    {steps.map((step, index) => (
                        <MyBetsRow step={step} index={index + 1} key={step.id}/>))}
                </div>
            )}
            {steps.length === 0 && loaded && (
                <div className={'items-center'}>
                    {t('myBets.empty.' + props.currentTab)}
                </div>
            )}
            {steps.length > 15 && showScrollToTop  && <UpButton/>}
        </div>
    );
}
